import { Search } from '@plone/volto/components';

export const IoVisitRoutes = (config) => {
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: '/**/search',
      component: Search,
    },
  ];
};
